// Utils
import { apiInstance, gql } from "@/services/httpAdapter";
import { errorLogger } from "@Common/helpers/logger";

// Types
import { ILocationCycles, IPaginationInput } from "@Common/types/common-queries";
import { GraphqlQueryResponse } from "@Common/api/types/GraphqlQueryResponse";
import { IBasicPaginatedQueryResponse } from "@Common/api/types/pagination";
import { IDeal } from "@Common/types/MyCit/model";

type TGetAllDealsArgs = ILocationCycles & { pagination: IPaginationInput };
export async function getAllDeals({ locationId, commissionCycleId, payPeriodId, pagination }: TGetAllDealsArgs) {
	const query = gql`
		query getAllDeals($locationId: String!, $commissionCycleId: String!, $payPeriodId: String!, $pagination: PaginationInput) {
			getAllDeals(
				locationId: $locationId
				commissionCycleId: $commissionCycleId
				payPeriodId: $payPeriodId
				pagination: $pagination
			) {
				items {
					_id
					locationId
					commissionCycleId
					payPeriodId
					age
					date
					stockNumber
					customerNumber
					customerName
					dealNumber
					vinNumber
					lender
					balance
					amountFinanced
					funded
					financeEmployee
					financeEmployeeId
					salesManager
					salesManagerEmployeeId
					salesEmployee
					salesEmployeeId
					trade
					dealStatus
					isUpdatedByCIT
					creationDate
					createdAt
					updatedAt
				}
				pageInfo {
					endCursor
					hasNextPage
				}
			}
		}
	`;

	const variables = {
		locationId,
		commissionCycleId,
		payPeriodId,
		pagination,
	};

	try {
		const response: GraphqlQueryResponse<"getAllDeals", IBasicPaginatedQueryResponse<IDeal>> = await apiInstance.post("/graphql", {
			query,
			variables,
		});
		return response.data.data?.getAllDeals ?? null;
	} catch (err) {
		errorLogger(err as Error, {});
		return null;
	}
}
